import { useAboutHouseDataLoading } from '../../AboutHomeContainer/utils';
import { useOffersHistoryDataLoading } from '../../OfferHistory/utils';

export function useDataLoadingOtherBlocks() {
  useAboutHouseDataLoading();
  useOffersHistoryDataLoading();
}
